"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormDeparturePicker = void 0;

var _react = _interopRequireWildcard(require("react"));

var _formik = require("formik");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _usehooksTs = require("usehooks-ts");

var _context = require("../../context");

var _constants = require("../../constants");

var _DeparturePicker = require("../DeparturePicker/DeparturePicker");

var _utils = require("../../utils");

var _useFetchAvailableDepartures = require("../../hooks/useFetchAvailableDepartures");

var _utils2 = require("../../../../utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var FormDeparturePicker = function FormDeparturePicker(_ref) {
  var options = _ref.value,
      name = _ref.name,
      isLoading = _ref.isLoading,
      className = _ref.className,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'default' : _ref$variant,
      _ref$isWidget = _ref.isWidget,
      isWidget = _ref$isWidget === void 0 ? false : _ref$isWidget,
      _ref$isOpenInitial = _ref.isOpenInitial,
      isOpenInitial = _ref$isOpenInitial === void 0 ? false : _ref$isOpenInitial,
      setBodyLocked = _ref.setBodyLocked,
      _ref$isWhiteLabel = _ref.isWhiteLabel,
      isWhiteLabel = _ref$isWhiteLabel === void 0 ? false : _ref$isWhiteLabel;

  var _useState = (0, _react.useState)(isOpenInitial),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isChooseAnyDeparture = _useState4[0],
      setIsChooseAnyDeparture = _useState4[1];

  var ref = (0, _react.useRef)(null);

  var _useField = (0, _formik.useField)(name),
      _useField2 = _slicedToArray(_useField, 3),
      value = _useField2[0].value,
      error = _useField2[1].error,
      _useField2$ = _useField2[2],
      setValue = _useField2$.setValue,
      setError = _useField2$.setError;

  var _useCigarette = (0, _context.useCigarette)(),
      _useCigarette$state = _useCigarette.state,
      steps = _useCigarette$state.steps,
      isMobile = _useCigarette$state.isMobile,
      isWizard = _useCigarette$state.isWizard,
      dispatch = _useCigarette.dispatch;
  /**
   * @deprecated Не использовать как значение пока не пропустишь через dto (тут данное состояние пока как булиан считай идет)
   * пока не знаю как архитектурно классно написать, но когда будем оптимизировать займемся у меня отдельный зуб на этот хук
   */


  var _useLocalStorage = (0, _usehooksTs.useLocalStorage)(_constants.storageKeys.departure, null),
      _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
      setSavedDeparture = _useLocalStorage2[1];

  var _useState5 = (0, _react.useState)(undefined),
      _useState6 = _slicedToArray(_useState5, 2),
      inputValue = _useState6[0],
      setInputValue = _useState6[1];

  var _useFetchAvailableDep = (0, _useFetchAvailableDepartures.useFetchAvailableDepartures)(options, isMobile),
      optionsWithAvailability = _useFetchAvailableDep.optionsWithAvailability; // Используем useEffect из-за того что isMobile приходит позднее рендера компонента


  (0, _react.useEffect)(function () {
    if (!isMobile) {
      setInputValue(value === null || value === void 0 ? void 0 : value.selectedLabel);
    } else {
      setInputValue(undefined);
    }
  }, [isMobile]);
  (0, _react.useEffect)(function () {
    setInputValue((value === null || value === void 0 ? void 0 : value.selectedLabel) || '');
  }, [value]);
  var menuIsOpenInWizard = (0, _utils.isDepartureStep)(steps);
  var menuIsOpen = isWizard ? menuIsOpenInWizard : open;
  var isDisabled = isWizard && !menuIsOpen;
  (0, _react.useEffect)(function () {
    if (error) {
      openMenu();
    }
  }, [error]);

  var onChange = function onChange(newValue, _ref2) {
    var action = _ref2.action;
    if (action === 'clear' && isMobile) return;
    setValue(newValue || undefined);

    if (newValue) {
      setSavedDeparture(newValue);
    }

    if (isChooseAnyDeparture) {
      setIsChooseAnyDeparture(false);
    }

    if (isWizard) {
      dispatch((0, _context.addStep)(_constants.FIELD_NAMES.datepicker));
    }

    closeMenu();
  };

  if (isWizard && !(0, _utils.afterDepartureStep)(steps)) {
    return null;
  }

  var openMenu = function openMenu() {
    setOpen(true);
    setBodyLocked === null || setBodyLocked === void 0 ? void 0 : setBodyLocked(true);
  };

  var closeMenu = function closeMenu() {
    setOpen(false);
    setError(undefined);
    setBodyLocked === null || setBodyLocked === void 0 ? void 0 : setBodyLocked(false);
  };

  var onInputChange = function onInputChange(currentValue, _ref3) {
    var action = _ref3.action;

    if (action === 'input-blur' && !_utils2.isTouchScreen) {
      setInputValue(value ? value.selectedLabel : undefined);
    }

    if (action === 'input-change') {
      setInputValue(currentValue);
      /**
       * Нужно, чтобы при очищении поля на десктопе в нём не оставалось
       * ранее выбранное значение
       */

      if (!currentValue) {
        setValue(undefined);
      }
    }
  };

  return /*#__PURE__*/_react["default"].createElement(FormDepartureContainer, {
    ref: ref,
    className: className,
    $isMobile: isMobile,
    $isWizard: isWizard
  }, /*#__PURE__*/_react["default"].createElement(_DeparturePicker.DeparturePicker, {
    isMobile: isMobile,
    options: optionsWithAvailability || [],
    onChange: onChange,
    menuIsOpen: menuIsOpen,
    isWizard: isWizard,
    isDisabled: isDisabled,
    value: value,
    onMenuOpen: openMenu,
    onMenuClose: closeMenu,
    isLoading: isLoading,
    inputValue: inputValue,
    onInputChange: onInputChange,
    variant: variant,
    isWidget: isWidget,
    isWhiteLabel: isWhiteLabel
  }));
};

exports.FormDeparturePicker = FormDeparturePicker;

var FormDepartureContainer = _styledComponents["default"].div.withConfig({
  displayName: "FormDeparturePicker__FormDepartureContainer",
  componentId: "sc-3so1hi-0"
})(["width:", ";position:relative;", ""], function (_ref4) {
  var $isMobile = _ref4.$isMobile;
  return $isMobile ? "100%" : "29.5%";
}, function (_ref5) {
  var $isMobile = _ref5.$isMobile,
      $isWizard = _ref5.$isWizard;
  return $isMobile && !$isWizard && "display: flex;\n    flex-direction: column;\n    ";
});